import { Stack, Grid, Typography, Button } from "@mui/material";
import { useNavigate} from "react-router-dom";
import useStorefrontStore from "../../../stores/public/useStorefrontStore";

export default function StorefrontHome() {
  const { itemCategories, organization, itemsByCategoryId } = useStorefrontStore();

  const navigate = useNavigate();

  return (
    <Stack>
      <Stack>
        <Grid container spacing={0}>
          {itemCategories.map((itemCategory) => itemsByCategoryId(itemCategory.id).length > 0 && (
            <Grid key={itemCategory.id} item xs={12} sm={6} lg={4} xl={3} mb={2} minHeight="65vh">
              <Grid container p={2} spacing={0}>
                <Grid item xs={12} display="flex">
                  <Stack
                    maxWidth="100%"
                    height="100%"
                    onClick={() => navigate(`/storefront/${organization.id}/item_categories/${itemCategory.id}`)}
                    sx={{
                      cursor: 'pointer',
                      borderRadius: '10px',
                      transition: 'box-shadow 0.3s',
                      '&:hover': {
                        boxShadow: '0 0 10px rgba(0,0,0,0.5)',
                      }
                    }}
                  >
                    <img src={itemCategory.image_url} alt={itemCategory.name} style={{ width: '320px', height: '320px', borderRadius: '10px 10px 0px 0px' }} />
                    <Stack borderRadius="0px 0px 10px 10px" bgcolor="#f7f7f7" p={2} width='320px' height="320px">
                      <Stack>
                        <Typography variant="h4" fontWeight="700">{itemCategory.name}</Typography>
                      </Stack>
                      <Stack height="250px" overflow="scroll">
                        <Stack mb={2}>
                          <Typography variant="body1" fontWeight="400"><i>{itemCategory.description}</i></Typography>
                        </Stack>
                      </Stack>
                      {itemCategory.lowest_price_dollars && <Stack mb={1}>
                        <Typography variant="h6">From ${parseFloat(itemCategory.lowest_price_dollars).toFixed(2)}</Typography>
                      </Stack>}
                      <Stack direction="row" justifyContent="center" mt="auto">
                        <Button sx={{ borderRadius: '100px' }} variant="contained" onClick={() => navigate(`/storefront/${organization.id}/item_categories/${itemCategory.id}`)}>Browse items</Button>
                      </Stack>
                    </Stack>
                  </Stack>
                </Grid>
              </Grid>
            </Grid>
          ))}
        </Grid>
      </Stack>
    </Stack>
  );
}